import { odata } from '../../conf';
import Actions from '../../odata/actions';

const actions = new Actions('canEndInspection', 'canEndInspections');

const customActions = {
  async LOAD_canEndInspections({ rootGetters, commit }) {
    const data = await odata.o(rootGetters)
      .get('canEndInspections')
      .query({
        $filter: 'isDeleted eq false',
        $expand: 'StockItem',
      });
    commit('SET_canEndInspections', data);
    return data;
  },
};

export default { ...actions, ...customActions };
